var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.353 22.5053H18.277C20.606 22.5053 22.5 20.6262 22.5 18.3172V9.58225C22.487 8.60025 22.029 7.69225 21.256 7.10325L14.674 1.85325C13.238 0.71525 11.233 0.71525 9.794 1.85525L3.259 7.10025C2.468 7.69925 2.01 8.60925 2 9.60325V18.3172C2 20.6262 3.894 22.5053 6.223 22.5053H8.147C9.172 22.5053 10.018 21.7313 10.126 20.7413C10.147 20.6733 10.157 20.6013 10.157 20.5263V17.4603C10.157 17.0943 10.462 16.7933 10.831 16.7913H13.717C14.094 16.7913 14.401 17.0913 14.401 17.4603V20.5363C14.401 21.6143 15.251 22.4793 16.353 22.5053Z",
    fill: "#7A5038"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActiveIcon);
export default __webpack_public_path__ + "static/media/homeActiveIcon.836e5218574c1e7d703a1ae36f5a5f19.svg";
export { ForwardRef as ReactComponent };